package org.vreo.devicehub.features.core.data.protocolBuffer.mappers

import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

import vreo.volt.protocol.AnprMessage
import org.vreo.devicehub.features.core.domain.device.message.AnprCameraMessage
import org.vreo.devicehub.features.core.domain.device.message.AnprCameraTelemetry

/**
 * Extension function to map a [AnprMessage] to a [AnprCameraMessage].
 */
@OptIn(ExperimentalTime::class)
fun AnprMessage.toAnprCameraMessage(): AnprCameraMessage {
    val instant = Instant.fromEpochSeconds(this.time_stamp)
    val localDateTime = instant.toLocalDateTime(TimeZone.currentSystemDefault())

    // Map telemetry readings to AnprCameraTelemetry objects
    val telemetry = this.telemetry.map { item ->
        val dateAndTime = Instant
            .fromEpochSeconds(item.time_stamp)
            .toLocalDateTime(TimeZone.currentSystemDefault())

        AnprCameraTelemetry(
            date = dateAndTime,
            cpuUsage = item.cpu_usage,
            cpuTemperature = item.cpu_temperature,
            ramUsage = item.ram_usage,
            enclosureHumidity = item.enclosure_humidity,
            enclosurePressure = item.enclosure_pressure,
            enclosureTemperature = item.enclosure_temperature
        )
    }

    // Create AnprCameraMessage
    return AnprCameraMessage(
        msgId = this.uuid,
        softwareVersion = this.software_version,
        ocrVersion = this.ocr_version,
        vehicleId = this.vehicle_id,
        licensePlate = this.license_plate,
        licensePlateWidth = this.license_plate_width,
        licensePlateHeight = this.license_plate_height,
        confidenceScore = this.confidence_score,
        ocrAttempt = this.ocr_attempt,
        imageUrl = this.image_url,
        date = localDateTime,
        timeStamp = this.time_stamp,
        telemetry = telemetry
    )
}